import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Message } from '@independent-software/typeui/controls/Message';
import { Placeholder } from '@independent-software/typeui/controls/Placeholder';

import { AuthContext } from '../../AuthContext';
import { Query } from '../../services';
import { Container, Content, BottomBar, Section } from '../../modules';
import { Parametercategory, ParametercategoryFactory } from '../../resource/';
import { CategoryTree } from '../../controls/CategoryTree';

const ParametercategoryList = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  const [parametercategories, setParametercategories] = React.useState([] as Parametercategory[]);

  React.useEffect(() => {
    // Retrieve a list of parametercategories:
    let query = new Query('name', 'asc');
    ParametercategoryFactory.getSome(auth, 0, 999, query)
      .then((res) => setParametercategories(res.items));
  }, []);

  const handleClick = (item: Parametercategory) => {
    navigate(`/parametercategories/${item.id}`);
  }

  const handleAdd = (item: Parametercategory, name: string) => {
    let cat = ParametercategoryFactory.create();
    cat.parent = item ? item.id : null;
    cat.name = name;
    cat.$save(auth)
    .then(res => {
      ToastService.toast("Parameter category created.");
      cat.id = res.data;
      setParametercategories([ ...parametercategories, cat ]);
    });
  }

  const handleEdit = (item: Parametercategory, name: string) => {
    item.name = name;
    item.$update(auth)
    .then(_ => {
      ToastService.toast("Parameter category updated.");
    });    
  }
  
  const handleDelete = (item: Parametercategory) => {
    const idx = parametercategories.indexOf(item);
    parametercategories.splice(idx, 1);
    setParametercategories(parametercategories);
    item.$delete(auth)
    .then(_ => {
      ToastService.toast("Parameter category deleted.");
    });        
  }

  return (
    <Container>
      <Content>
        <Section padded="very">
          {parametercategories == null && <>
            <Placeholder>
              <Placeholder.Header image>
                <Placeholder.Line tall/>
                <Placeholder.Line tall/>
              </Placeholder.Header>
            </Placeholder>
          </>}
          {parametercategories != null && 
            <>
              {parametercategories.length == 0 && 
                <Message type="info">
                  No parameter categories have been defined yet.
                </Message>}    
              <CategoryTree 
                items={parametercategories} 
                onClick={handleClick}
                onAdd={auth.hasRight('can_edit_parametercategories') && handleAdd} 
                onEdit={auth.hasRight('can_edit_parametercategories') && handleEdit} 
                onDelete={auth.hasRight('can_delete_parametercategories') && handleDelete}
                countfield="parameters_count"
                />
            </>}
        </Section>
      </Content>
      <BottomBar>
      </BottomBar>
    </Container>
  );
}

export { ParametercategoryList }
